// ⚠ KEEP IN SYNC with netlify/functions/lib/watchlistMatching.js — same
// logic, different module systems (this file is ES module for the React
// frontend; that one is CommonJS for Netlify functions).
//
// CRA's webpack blocks imports outside src/, so a shared file requires
// build config we don't want to invent yet. If you change matching
// behaviour here, edit the other file too.

export function normalizeWatchlistTitle(s) {
  if (!s) return '';
  return s
    .toLowerCase()
    // Roxy formats compilations as "Primary | Secondary Series Label" —
    // drop everything after the first `|`.
    .split('|')[0]
    // Strip anniversary suffixes that AMC, Angelika, Studio Ghibli Fest etc.
    // append to repertory titles: "Citizen Kane 85th Anniversary",
    // "Amores Perros: 25th Anniversary",
    // "Castle in the Sky 40th Anniversary - Studio Ghibli Fest 2026".
    .replace(/[\s:]+\d+(?:st|nd|rd|th)\s+anniversary.*$/i, '')
    // Strip trailing (YYYY) year stamp.
    .replace(/\s*\(\d{4}\)\s*$/, '')
    // Strip remaining minor punctuation that varies between sources.
    .replace(/[-:''.,!?()]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function isWatchlistTitleMatch(watchlistTitle, cinemaTitle) {
  const a = normalizeWatchlistTitle(watchlistTitle);
  if (!a) return false;
  return normalizeWatchlistTitle(cinemaTitle) === a;
}

// Movie-id-first matcher. Prefers exact movie_id equality (resilient to
// title drift between IST API, TMDB, and theater billing). Falls back to
// normalized-title equality when either side has no movie_id, so legacy
// watchlist rows (e.g. Letterboxd CSV imports without TMDB ids) still match.
export function isWatchlistMatch({ watchlistMovieId, watchlistTitle, showMovieId, showTitle }) {
  if (watchlistMovieId && showMovieId) {
    return String(watchlistMovieId) === String(showMovieId);
  }
  return isWatchlistTitleMatch(watchlistTitle, showTitle);
}
